<template>
    <span>
        <nio-icon class="text-lg text-gray-400" name="bold/subtract-circle" v-if="isEmpty" />
        <slot v-else>
            {{ value }}
        </slot>
    </span>
</template>

<script>
    export default {
        props: {
            value: {
                type: null,
                required: true,
            },
        },

        computed: {
            isEmpty() {
                if (typeof this.value === 'string') {
                    return !this.value.trim();
                }

                if (Array.isArray(this.value)) {
                    return !this.value.length;
                }

                return !this.value;
            },
        },
    };
</script>
